import React, { createContext, useContext, useState } from "react"
import { LOGIN_FORM } from "./formTypes"

const FormContext = createContext();

export const FormContextProvider = props => {
    const [content, setContent] = useState(LOGIN_FORM)

  return (
    <FormContext.Provider value={{content, setContent}}>
      {props.children}
    </FormContext.Provider>
  );
}

export const useFormContext = () => {
    return useContext(FormContext);
}
